export default "__VITE_ASSET__CrAIrYIJ__"